<template>
  <div>
    <label class="flex flex-col text-16">
      <div v-if="label" class="flex justify-between items-end" :class="labelClass">
        <p>{{ label }}</p>
        <router-link
          v-if="forgotPassword"
          to="/reset-password"
          class="text-13 md:text-opacity-50 hover:text-opacity-100 font-normal"
        >
          Forgot password?
        </router-link>
      </div>
      <div class="relative">
        <input
          ref="inputRef"
          v-model="value"
          :type="type"
          :placeholder="placeholder"
          class="w-full rounded-4 outline-none"
          :class="[
            hasBackground ? isDarkMode ? 'bg-hover text-app-color' : 'bg-grey-400' : '',
            inputClasses,
            shadow,
            errorMessage && 'shadow-error']"
          :disabled="disabled"
          :readonly="readonly"
          :maxlength="maxLength"
          :max="maxLength"
          @blur="$emit('blur')"
          @focus="$emit('focus')"
          @input="$emit('input')"
        >
        <!-- COPY LINK BUTTON -->
        <slot />
        <span
          v-if="errorMessage"
          class="absolute -bottom-20 left-10 text-error text-12"
        >
          {{ errorMessage }}
          <router-link v-if="isNeedLink" to="/login" class="text-app-color">Please login</router-link>
        </span>
      </div>
    </label>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'InputModule',

  props: {
    label: { type: String, default: '' },
    type: { type: String, default: 'text' },
    name: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    shadow: { type: String, default: 'focus:shadow-outline' },
    hasBackground: { type: Boolean, default: true },
    inputClasses: { type: String, default: 'px-13 py-9' },
    labelClass: { type: String, default: 'md:mx-5 mb-10' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    modelValue: { type: String, default: '' },
    errorMessage: { type: String, default: null },
    forgotPassword: { type: Boolean, default: false },
    isNeedLink: { type: Boolean, default: false },
    maxLength: String
  },

  emits: ['update:modelValue', 'clearErrorMessage', 'blur', 'focus', 'input'],

  setup (props, { emit }) {
    const { getters } = useStore()

    const inputRef = ref(null)

    const isDarkMode = computed(() => getters.isDarkMode)

    const value = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val)
        emit('clearErrorMessage', props.name)
      }
    })

    function focus () {
      inputRef.value.focus()
    }

    return {
      // computed
      isDarkMode,
      value,
      // refs
      inputRef,
      // functions
      focus
    }
  }
})
</script>
